var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7546_139745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.197 114.04C88.5609 114.04 113.986 88.6146 113.986 57.2508C113.986 25.8869 88.5609 0.461487 57.197 0.461487C25.8331 0.461487 0.407715 25.8869 0.407715 57.2508C0.407715 88.6146 25.8331 114.04 57.197 114.04Z",
    fill: "#665A3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9317 91.4365C52.0269 91.4365 40.8053 85.9058 37.1583 83.902V55.0465C46.6966 53.2831 52.9086 47.6322 55.6338 38.2541C57.7579 30.9601 56.8762 24.0268 56.8762 23.9466C56.8361 23.7061 56.9163 23.4256 57.1167 23.2653C57.3171 23.105 57.5575 23.0248 57.798 23.0649C63.4889 24.147 67.2562 26.6318 69.0997 30.5192C72.1055 36.9717 68.8192 45.1474 67.3363 48.1933H70.6227C68.8593 49.5559 67.7371 51.68 67.7371 54.0846C67.7371 56.0484 68.4986 57.8518 69.741 59.1744C68.4986 60.4969 67.7371 62.3004 67.7371 64.2642C67.7371 66.228 68.4986 68.0314 69.741 69.354C68.4986 70.6765 67.7371 72.48 67.7371 74.4438C67.7371 76.4076 68.4986 78.211 69.741 79.5336C68.4986 80.8962 67.7371 82.6596 67.7371 84.6234C67.7371 87.3085 69.1398 89.633 71.2238 90.9556C69.1799 91.2762 67.0959 91.4365 64.9317 91.4365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3311 59.976H75.2317C71.9854 59.976 69.3403 57.3309 69.3403 54.0846C69.3403 50.8384 71.9854 48.1933 75.2317 48.1933H85.3311C88.5774 48.1933 91.2224 50.8384 91.2224 54.0846C91.2224 57.3309 88.5774 59.976 85.3311 59.976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3311 70.1555H75.2317C71.9854 70.1555 69.3403 67.5104 69.3403 64.2642C69.3403 61.018 71.9854 58.3729 75.2317 58.3729H85.3311C88.5774 58.3729 91.2224 61.018 91.2224 64.2642C91.2224 67.5104 88.5774 70.1555 85.3311 70.1555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3311 80.3352H75.2317C71.9854 80.3352 69.3403 77.6901 69.3403 74.4438C69.3403 71.1976 71.9854 68.5525 75.2317 68.5525H85.3311C88.5774 68.5525 91.2224 71.1976 91.2224 74.4438C91.2224 77.6901 88.5774 80.3352 85.3311 80.3352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3311 90.5147H75.2317C71.9854 90.5147 69.3403 87.8696 69.3403 84.6234C69.3403 81.3771 71.9854 78.7321 75.2317 78.7321H85.3311C88.5774 78.7321 91.2224 81.3771 91.2224 84.6234C91.2224 87.8696 88.5774 90.5147 85.3311 90.5147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5552 83.2207H23.9729C23.5321 83.2207 23.1714 82.86 23.1714 82.4191V55.9682C23.1714 55.5274 23.5321 55.1667 23.9729 55.1667H35.5552V83.2207Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7546_139745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113.539,
    height: 113.539,
    fill: "white",
    transform: "translate(0.407715 0.461487)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsLike);
export default __webpack_public_path__ + "static/media/contact-us-like.4e833697cdd6a7f7800bb7e21ca25654.svg";
export { ForwardRef as ReactComponent };